import { useCallback, useEffect, useState } from "react";
import axios from "axios";

const API_BASE = process.env.REACT_APP_BACKEND_URL || "";

function normalizeAxiosError(e) {
    return e?.response?.data?.error || e?.message || "Unbekannter Fehler";
}

export default function useHotelGroups() {
    const [hotelGroups, setHotelGroups] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const fetchHotelGroups = useCallback(async () => {
        setLoading(true);
        setError("");
        try {
            const res = await axios.get(`${API_BASE}/api/hotel-groups`, { withCredentials: true });
            const data = res.data?.hotel_groups ?? res.data ?? [];
            setHotelGroups(Array.isArray(data) ? data : []);
        } catch (e) {
            setError(normalizeAxiosError(e));
        } finally {
            setLoading(false);
        }
    }, []);

    const createHotelGroup = useCallback(async (payload) => {
        try {
            const res = await axios.post(`${API_BASE}/api/hotel-groups`, payload, { withCredentials: true });
            await fetchHotelGroups();
            return res.data?.hotel_group;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchHotelGroups]);

    const updateHotelGroup = useCallback(async (id, payload) => {
        try {
            const res = await axios.put(`${API_BASE}/api/hotel-groups/${id}`, payload, { withCredentials: true });
            await fetchHotelGroups();
            return res.data?.hotel_group;
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchHotelGroups]);

    const deleteHotelGroup = useCallback(async (id) => {
        try {
            await axios.delete(`${API_BASE}/api/hotel-groups/${id}`, { withCredentials: true });
            await fetchHotelGroups();
        } catch (e) {
            throw new Error(normalizeAxiosError(e));
        }
    }, [fetchHotelGroups]);

    useEffect(() => {
        fetchHotelGroups();
    }, [fetchHotelGroups]);

    return {
        hotelGroups,
        loading,
        error,
        fetchHotelGroups,
        createHotelGroup,
        updateHotelGroup,
        deleteHotelGroup,
    };
}
